// src/components/Onboarding/BenefitsDisplay.js

import React from 'react';
import happyKid from '../../images/happy_kid.png';

// Gradient configurations - matching EXACT colors from ConversionSlide CARD_GRADIENTS
const BENEFIT_GRADIENTS = [
  { from: '#41537C', to: '#6387DB' }, // candidateScore - blue/indigo
  { from: '#277D48', to: '#37AC64' }, // expectedCost - green
  { from: '#AC3FBC', to: '#E570F7' }, // expectedSatisfaction - purple/magenta
  { from: '#A6502B', to: '#ED956F' }, // medicalBackground - orange/brown
  { from: '#208EA1', to: '#5FD9DF' }, // aestheticGoals - cyan/teal
  // Additional contrasting gradients following the same approach
  { from: '#B84592', to: '#F093D7' }, // pink/magenta
  { from: '#7C5C3F', to: '#C9A47D' }, // brown/tan
];

function BenefitBlock({ text, widthFraction = 1, gradientIndex = 0 }) {
  const gradient = BENEFIT_GRADIENTS[gradientIndex % BENEFIT_GRADIENTS.length];
  const widthClass = widthFraction === 1 ? 'flex-1' : '';
  const flexBasis = widthFraction < 1 ? { flexBasis: `${widthFraction * 100}%` } : {};
  
  return (
    <div
      className={`${widthClass} rounded-xl px-3 flex items-center justify-center text-white text-sm font-semibold text-center whitespace-nowrap overflow-hidden`}
      style={{
        background: `linear-gradient(to bottom right, ${gradient.from}, ${gradient.to})`,
        height: '36px',
        ...flexBasis,
      }}
    >
      {text}
    </div>
  );
}

export default function BenefitsDisplay() {
  return (
    <div className="w-full max-w-md mx-auto">
      {/* Top image - 50% size */}
      <div className="w-full flex justify-center mb-4 mt-12">
        <div className="w-2/3">
          <img 
            src={happyKid} 
            alt="Happy person" 
            className="w-full h-auto object-cover rounded-2xl"
          />
        </div>
      </div>

      {/* Title */}
      <h2 className="text-white text-xl font-bold text-center mb-6 leading-tight">
        Continue to explore your hair transplant options now
      </h2>

      {/* Colored blocks section */}
      <div className="space-y-2 mb-6">
        {/* Row 1: Green + Purple (contrasting) */}
        <div className="flex gap-2">
          <BenefitBlock text="No commitment" widthFraction={0.45} gradientIndex={1} />
          <BenefitBlock text="Absolutely free" widthFraction={0.55} gradientIndex={2} />
        </div>

        {/* Row 2: Cyan (contrasts with purple above and orange below) */}
        <div className="flex gap-2">
          <BenefitBlock text="Easily communicate via text" widthFraction={1} gradientIndex={4} />
        </div>

        {/* Row 3: Orange + Blue (contrasting) */}
        <div className="flex gap-2">
          <BenefitBlock text="24/7 human support" widthFraction={0.58} gradientIndex={3} />
          <BenefitBlock text="No hidden fees" widthFraction={0.42} gradientIndex={0} />
        </div>

        {/* Row 4: Pink + Brown (contrasting) */}
        <div className="flex gap-2">
          <BenefitBlock text="No fear" widthFraction={0.25} gradientIndex={5} />
          <BenefitBlock text="Best clinics by reviews" widthFraction={0.75} gradientIndex={6} />
        </div>
      </div>
    </div>
  );
}
